import { ApiService } from "../../../../services/apiService";
import { history } from "../../../../shared/_helpers/history";
import { Dispatch } from "redux";
import { appConstants } from "../../../action-constants/inapp.constants";
import { routes } from "../../../../services/paths";
import { handleRequestErrors } from "../../../../shared/utils";
import {
    BulkProductDeletePayload,
  BulkProductUpdatePayload,
  CreateProductPayload,
  DeleteStoreProductPayload,
  ToggleProductPayload,
  UpdateProductPayload,
  UploadProductImagePayload,
} from "../../../../types/ProductTypes";

export const CreateStoreProduct = (
  actionPayload: CreateProductPayload | "CLEAR"
) => {
  if (actionPayload !== "CLEAR") {
    return (dispatch: Dispatch) => {
      let apiConsume = ApiService.request({
        url: routes.CREATE_PRODUCT,
        http_method: "POST",
        data: actionPayload,
      });
      dispatch(request(apiConsume));
      return apiConsume
        .then((response: any) => {
          dispatch(success(response.data));
          history.replace("/app/my-products");
        })
        .catch((error: any) => {
          dispatch(failure(handleRequestErrors(error)));
        });
    };
  }

  return (dispatch: Dispatch) => {
    dispatch(clear());
  };

  function request(params: any) {
    return { type: appConstants.CREATE_PRODUCT_PENDING, params };
  }
  function success(response: any) {
    return { type: appConstants.CREATE_PRODUCT_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: appConstants.CREATE_PRODUCT_FAILURE, error };
  }
  function clear() {
    return { type: appConstants.CREATE_PRODUCT_RESET, clear_data: "" };
  }
};

export const UpdateStoreProduct = (
  actionPayload: UpdateProductPayload | "CLEAR"
) => {
  if (actionPayload !== "CLEAR") {
    return (dispatch: Dispatch) => {
      let apiConsume = ApiService.request({
        url: routes.UPDATE_PRODUCT,
        http_method: "PUT",
        data: actionPayload,
      });
      dispatch(request(apiConsume));
      return apiConsume
        .then((response: any) => {
          dispatch(success(response.data));
          // Only redirect if the response indicates success
          // Let the component handle redirect based on Redux state
        })
        .catch((error: any) => {
          dispatch(failure(handleRequestErrors(error)));
        });
    };
  }

  return (dispatch: Dispatch) => {
    dispatch(clear());
  };

  function request(params: any) {
    return { type: appConstants.UPDATE_PRODUCT_PENDING, params };
  }
  function success(response: any) {
    return { type: appConstants.UPDATE_PRODUCT_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: appConstants.UPDATE_PRODUCT_FAILURE, error };
  }
  function clear() {
    return { type: appConstants.UPDATE_PRODUCT_RESET, clear_data: "" };
  }
};

export const UploadProductImage = (
  actionPayload: UploadProductImagePayload | "CLEAR",
  otherNames: any
) => {
  if (actionPayload !== "CLEAR") {
    return (dispatch: Dispatch) => {
      let apiConsume = ApiService.request({
        url: routes.PRODUCT_IMAGE_UPLOAD,
        http_method: "POST",
        data: actionPayload,
      });
      dispatch(request(apiConsume));
      return apiConsume
        .then((response: any) => {
          // if (response?.data) {

          let responseData = { ...response.data, otherNames };
          dispatch(success(responseData));

          // }
        })
        .catch((error: any) => {
          dispatch(failure(handleRequestErrors(error)));
        });
    };
  }

  return (dispatch: Dispatch) => {
    dispatch(clear());
  };

  function request(params: any) {
    return { type: appConstants.UPLOAD_PRODUCT_PICTURE_PENDING, params };
  }
  function success(response: any) {
    return { type: appConstants.UPLOAD_PRODUCT_PICTURE_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: appConstants.UPLOAD_PRODUCT_PICTURE_FAILURE, error };
  }
  function clear() {
    return { type: appConstants.UPLOAD_PRODUCT_PICTURE_RESET, clear_data: "" };
  }
};

export const GetMyProductList = (actionPayload: string) => {
  if (actionPayload !== "CLEAR") {
    let loggedAccountInfo: any =
      localStorage.getItem("mamiVendorXAuth") || "{}";
    loggedAccountInfo = JSON.parse(loggedAccountInfo);
    let payload = `StoreId=${loggedAccountInfo.selectedStore.id}&${actionPayload}`;
    return (dispatch: Dispatch) => {
      let apiConsume = ApiService.request({
        url: `${routes.GET_VENDORS_PRODUCTS}?${payload}`,
        http_method: "GET",
      });
      dispatch(request(apiConsume));
      return apiConsume
        .then((response: any) => {
          dispatch(success(response.data));
        })
        .catch((error: any) => {
          dispatch(failure(handleRequestErrors(error)));
        });
    };
  }

  return (dispatch: Dispatch) => {
    dispatch(clear());
  };

  function request(params: any) {
    return { type: appConstants.GET_PRODUCTS_PENDING, params };
  }
  function success(response: any) {
    return { type: appConstants.GET_PRODUCTS_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: appConstants.GET_PRODUCTS_FAILURE, error };
  }
  function clear() {
    return { type: appConstants.GET_PRODUCTS_RESET, clear_data: "" };
  }
};

export const ToggleAProduct = (
  actionPayload: ToggleProductPayload | "CLEAR",
  callback: () => void
) => {
  if (actionPayload !== "CLEAR") {
    return (dispatch: Dispatch) => {
      let apiConsume = ApiService.request({
        url: `${routes.TOGGLE_PRODUCT}${actionPayload?.storeId}/Product/${actionPayload?.productId}/Toggle`,
        http_method: "GET",
      });
      dispatch(request(apiConsume));
      return apiConsume
        .then((response: any) => {
          callback();
          dispatch(success(response.data));
        })
        .catch((error: any) => {
          dispatch(failure(handleRequestErrors(error)));
        });
    };
  }

  return (dispatch: Dispatch) => {
    dispatch(clear());
  };

  function request(params: any) {
    return { type: appConstants.TOGGLE_A_PRODUCT_PENDING, params };
  }
  function success(response: any) {
    return { type: appConstants.TOGGLE_A_PRODUCT_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: appConstants.TOGGLE_A_PRODUCT_FAILURE, error };
  }
  function clear() {
    return { type: appConstants.TOGGLE_A_PRODUCT_RESET, clear_data: "" };
  }
};

export const DeleteStoreProduct = (actionPayload: DeleteStoreProductPayload | "CLEAR") => {
  if (actionPayload !== "CLEAR") {
    return (dispatch: Dispatch) => {
      let apiConsume = ApiService.request({
        url: `${routes.DELETE_PRODUCT(actionPayload.storeId, actionPayload.productId)}`,
        http_method: "DELETE",
      });
      dispatch(request(apiConsume));
      return apiConsume
        .then((response: any) => {
          dispatch(success(response.data));
        })
        .catch((error: any) => {
          dispatch(failure(handleRequestErrors(error)));
        });
    };
  }

  return (dispatch: Dispatch) => {
    dispatch(clear());
  };

  function request(params: any) {
    return { type: appConstants.DELETE_A_PRODUCT_PENDING, params };
  }
  function success(response: any) {
    return { type: appConstants.DELETE_A_PRODUCT_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: appConstants.DELETE_A_PRODUCT_FAILURE, error };
  }
  function clear() {
    return { type: appConstants.DELETE_A_PRODUCT_RESET, clear_data: "" };
  }
};

export const PermanentDeleteProduct = (actionPayload: DeleteStoreProductPayload | "CLEAR") => {
  if (actionPayload !== "CLEAR") {
    return (dispatch: Dispatch) => {
      let apiConsume = ApiService.request({
        url: `${routes.PERMANENT_DELETE_PRODUCT(actionPayload.storeId, actionPayload.productId)}`,
        http_method: "DELETE",
      });
      dispatch(request(apiConsume));
      return apiConsume
        .then((response: any) => {
          dispatch(success(response.data));
        })
        .catch((error: any) => {
          dispatch(failure(handleRequestErrors(error)));
        });
    };
  }

  return (dispatch: Dispatch) => {
    dispatch(clear());
  };

  function request(params: any) {
    return { type: appConstants.DELETE_A_PRODUCT_PENDING, params };
  }
  function success(response: any) {
    return { type: appConstants.DELETE_A_PRODUCT_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: appConstants.DELETE_A_PRODUCT_FAILURE, error };
  }
  function clear() {
    return { type: appConstants.DELETE_A_PRODUCT_RESET, clear_data: "" };
  }
};

export const BulkProductUpdate = (actionPayload: BulkProductDeletePayload | BulkProductUpdatePayload | "CLEAR", action?: string) => {
  if (actionPayload !== "CLEAR") {
    return (dispatch: Dispatch) => {
      let url = "",
        http_method = "";

      if (action === "edit") {
        url = routes.BULK_UPDATE;
        http_method = "PUT";
      }
      if (action === "delete") {
        url = routes.BULK_DELETE;
        http_method = "POST";
      }
      let apiConsume = ApiService.request({
        url,
        http_method,
        data: actionPayload,
      });
      dispatch(request(apiConsume));
      return apiConsume
        .then((response: any) => {
          // if (response?.data) {

          dispatch(success(response.data));
          history.replace("/app/my-products");
          // history.replace("/app/my-products/success")

          // }
        })
        .catch((error: any) => {
          dispatch(failure(handleRequestErrors(error)));
        });
    };
  }

  return (dispatch: Dispatch) => {
    dispatch(clear());
  };

  function request(params: any) {
    return { type: appConstants.BULK_UPDATE_PENDING, params };
  }
  function success(response: any) {
    return { type: appConstants.BULK_UPDATE_SUCCESS, response };
  }
  function failure(error: any) {
    return { type: appConstants.BULK_UPDATE_FAILURE, error };
  }
  function clear() {
    return { type: appConstants.BULK_UPDATE_RESET, clear_data: "" };
  }
};